/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Branch_NameInputs */

const vi_shop_home_branch_name = /** @type {(inputs: Shop_Home_Branch_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên chi nhánh`)
};

/**

* @param {Shop_Home_Branch_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_branch_name = /** @type {((inputs?: Shop_Home_Branch_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Branch_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_branch_name(inputs)
});